import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { CreateCategoryProduct, EditCategoryProduct, SeeCategories } from '../../../../actions/pCategoriesActions'
import CategoriesListView from '../../../../containers/Inventory/Products/Categories/CategoriesList/CategoriesList'
//import { getCategories } from '../../../../../actions/regiterActions'

const CategoriesList = () => {
    const dispatch = useDispatch()
    const { isLoadingCategoriesList, categoriesList } = useSelector(state => state.categoriesAdmin)
    useEffect(() => {
        dispatch(SeeCategories())
       // dispatch(getproductc)
      return () => {
        
      }
    }, [])
    const [isEdit, setIsEdit] = useState(false)
    const formik = useFormik({
      initialValues:{
        name:""
      },
      onSubmit:(values)=>{
        if(isEdit){
          dispatch(EditCategoryProduct(values.name,values.id,()=>formik.resetForm()))
        }else{
          dispatch(CreateCategoryProduct(values.name,()=>formik.resetForm()))
        }
  
      }
    })
    
  return (
    <CategoriesListView categories ={categoriesList} isEdit={isEdit} formik={formik} setIsEdit={setIsEdit}/>
  )
}

export default CategoriesList